{
  "settingsPresenter": {
    "title": "Settings – {{fboName}}",
    "newHangarName": "New Hangar",
    "buttons": {
      "addHangar": "Add Hangar"
    },
    "tabs": {
      "hangars": "Hangars",
      "ramps": "Ramps",
      "stackingSOPs": "Stacking SOPs",
      "towingEquipment": "Towing Equipment",
      "estimation": "Estimation",
      "opsCenter": "Ops Center",
      "teamMembers": "Team Members",
      "configuration": "Configuration",
      "reports": "Reports",
      "integrations": "Integrations",
      "account": "Account"
    }
  },
  "rampsSettings": {
    "rampEditor": {
      "properties": "Properties",
      "rampVersion": "Ramp Version",
      "v2Algorithm": "V2 Algorithm",
      "toolbar": {
        "selectSpotSize": "Select spot size"
      }
    }
  }
}
